import React, { useEffect, useState } from 'react';
import {
    Button, Cell, DialogContainer,

    SelectField
} from 'react-md';
import MultiSelectReact from 'react-multi-select-ext';
import { browserHistory } from 'react-router';
import ApiRequestService from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';
import Properties from '../component/Properties';
import { AppProperties } from '../common/function';

const selectedOptionsStyles = {
    color: '#FFFFFF',
    backgroundColor: '#bb0000'
};
const optionsListStyles = {
    backgroundColor: '#FFFFFF',
    color: '#bb0000'
};



const CopyQuizDialog = ({visible,onHide,courses,quizID, isLTIEnabled, isMatrix, onCompleteCopyAssignment}) => {



    let appProperties = AppProperties();
    let baseFolder = appProperties.baseFolder;
    
    const [loading,setLoading] = useState(false);
    const [sectionLoading,setSectionLoading] = useState(false);

    const [course,setCourse] = useState(undefined);
    const [sections,setSections] = useState([]);
    const [sectionsArray,setSectionsArray] = useState([]);
    const [sectionsSelected,setSectionsSelected] = useState(undefined);
    const [selectSectionID,setSelectSectionID] = useState([]);

    const actions = [];


    const onCopyClicked = () => {
        setLoading(true);
        const payload = {quizID: quizID,courseID: course.value,sectionIDs:sectionsSelected};
        ApiRequestService({
            method: 'post',
            url: '/copyquiz',
            data: payload
          })
            .then(res => {
                if (
                    res && res.data && res.data.data
                ){
                    if (isMatrix) {
                        if (onCompleteCopyAssignment) {
                            onCompleteCopyAssignment({ ...payload, newQuizID: res.data.data });
                        }
                    } else {
                        //Redirect to the Quiz Page
                        browserHistory.push( `${baseFolder}QuizCreation?course_id=${course.value}&quiz_id=${res.data.data}&is_lti_enabled=${course.isLTICourse}`);
                    }
                }
            })
            .catch(error => {
              console.error('Error When Retriving Section Details ', error);
            }).finally(()=>{
                setLoading(false);
            });
        
    }
    
    const onCourseChange = (_,index) => {
        setCourse({...courses[index]});
    };

    const getSections =()=>{
        if(course){
            setSections([]);
            setSectionsSelected([]);
            setSectionsArray([]);
            setSectionLoading(true);
            const payload = { course_id: course.value };
            ApiRequestService({
                method: 'post',
                url: '/getAllSections',
                data: payload
            })
            .then(res => {
                setSectionLoading(false);

                if (
                    res && res.data && res.data.data &&
                    res.data.data.section_names &&
                    res.data.data.section_names.length > 0
                ) {
                    setSectionsArray([...res.data.data.section_names]);
                    const section_list = res.data.data.section_names.map((section,index)=>{
                        return {'label':section.section_name,'id':index,'value':false};
                    });
                    setSections(section_list);
                }
            })
            .catch(error => {
                console.error('Error When Retriving Section Details ', error);
            });
        }
    };

    const onSectionSelect = (vals) => {
        const selectedValues = [];
       
        vals.forEach((section,index) => {
            if(section.value === true){
                selectedValues.push(sectionsArray[section.id].section_id);
            } 
        });

        setSections([...vals]);
        setSectionsSelected(selectedValues)
    }

    const onSingleSectionSelected = (value) =>{
        console.debug(value)
        const temp = sections.map(section => {
          var returnValue = {...section,value:false};

          if (section.id === value) {
            returnValue.value = true;
          }
          return returnValue
        });
        setSections(temp)
        setSelectSectionID(value)
        setSectionsSelected([sectionsArray[value].section_id])
      }
      
    //Load Sections on Course Select
    useEffect(getSections,[course]);

    //Reset on Dialog Load
    useEffect(()=>{
        if(visible){
            setLoading(false);
            setCourse(undefined);
            setSections([]);
            setSectionsArray([]);
            setSectionsSelected([]);
            setSelectSectionID([]);
        }
    },[visible])
    
    //Buttons
    actions.push({ secondary: true, children: 'Cancel', onClick: onHide });
    actions.push(<Button raised primary onClick={onCopyClicked} disabled={!course || !sectionsSelected || sectionsSelected.length <= 0 || loading} >Copy</Button>);

    

    return <DialogContainer
                id="copy-quiz-dialog"
                title="Copy Assignment"
                visible={visible}
                onHide={onHide}
                contentClassName="md-grid copy-quiz-dialog"
                aria-describedby="copy-quiz-instructions"
                modal
                width={600}
                actions={actions}
            >
                {
                   loading ?
                   <LoadingSpinner loading={loading} />
                   :
                   <React.Fragment>
                        <Cell size={12} id="copy-quiz-instructions" className='md-body-2' style={{
                            textAlign:'left'
                        }}>
                            <div style={{marginBottom:'5px'}}>Please select a course and one or more sections under it, and copy , to copy the assignment.</div>
                            {/* {!isLTIEnabled ? "NOTE: Assignment that is copied will be unpublished by default." : null} */}
                        </Cell>
                        <Cell size={12}>
                            <SelectField
                                    id="selectCourses"
                                    placeholder="Select   Course"
                                    itemLabel="title"
                                    itemValue="quiz_id"
                                    menuItems={courses}
                                    onChange={onCourseChange}
                                    fullWidth
                            />
                        </Cell>
                        <Cell size={12}>
                        {
                            sectionLoading ?
                                <LoadingSpinner loading={sectionLoading} />
                            :
                           
                                sections.length > 0 ?
                                <React.Fragment>
                                    {appProperties.enableLTI?
                                        <SelectField
                                        id="quiz-section-select"
                                        fullWidth={true}
                                        onChange={onSingleSectionSelected}
                                        menuItems={sections}
                                        value={selectSectionID}
                                        itemValue="id"
                                        style={{
                                            color:"#000d11",
                                            fontSize:"14px"
                                        }}
                                        />
                                        :
                                        <MultiSelectReact
                                        options={sections}
                                        selectedOptionsStyles={selectedOptionsStyles}
                                        optionsListStyles={optionsListStyles}
                                        enableSelectAllNone={false}
                                        optionClicked={onSectionSelect}
                                        selectedBadgeClicked={onSectionSelect}
                                        />}
                                </React.Fragment>:
                                undefined
                            }
                        </Cell>  
                    </React.Fragment>  
                }
            </DialogContainer>
};

export default CopyQuizDialog;